<template>
  <div class="evidence-category-card__patient-id">
    <label :for="inputId" class="evidence-category-card__patient-id-label">
      {{ $t('app.assessment_mode.text.input.patient_id_label') }}
    </label>
    <input
        :id="inputId"
        :value="value"
        type="text"
        class="evidence-category-card__patient-id-input"
        :class="{ 'evidence-category-card__patient-id-input--error': invalid }"
        :placeholder="String($t('app.assessment_mode.text.input.patient_id_placeholder'))"
        :aria-invalid="invalid ? 'true' : undefined"
        :aria-describedby="invalid ? errorId : undefined"
        @input="handleInput"
        @change="$emit('change')"
    />
    <div v-if="invalid" :id="errorId" class="evidence-category-card__patient-id-error" role="alert">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

const ERROR_TOKEN = 'questions.patient_id.error';

export default defineComponent({
  name: 'PatientIdField',

  props: {
    inputId: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    invalid: {
      type: Boolean,
      default: false,
    },
  },

  setup(_, { emit }) {
    const handleInput = (event: Event): void => {
      emit('input', (event.target as HTMLInputElement).value);
    };

    return {
      handleInput,
    };
  },

  computed: {
    errorId(): string {
      return `${this.inputId}-error`;
    },
    errorMessage(): string {
      const message = String(this.$t(ERROR_TOKEN));
      return message === ERROR_TOKEN
        ? `Enter a valid ${this.$t('app.assessment_mode.text.input.patient_id_label')}`
        : message;
    },
  },
});
</script>
